const GridCaptions = ({ data }) => {
    // TODO: Finish component - when backend shows where are entraces and other data

    return <div className={'grid-captions'}></div>
}

export default GridCaptions
